import $ from 'jquery'

export default function responsiveMenuInit() {
    let burger = document.getElementById('nav-icon3'),
        menu = document.querySelector('.nav-mobile .header__menu'),
        setLang = $('#js-lang-mobile');

    burger.addEventListener('click', function() {
      document.body.classList.toggle('nav-open');
    });

    menu.addEventListener('click', function(e) {
      if(e.target.tagName === 'A') {
        document.body.classList.remove('nav-open');
      }
    })

    setLang.dropdown();

}



// WEBPACK FOOTER //
// ./src/js/menu.js